var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SearchPanel'),(_vm.songs.length > 0)?_c('Webamp',{attrs:{"initial-songs":_vm.songs,"config":_vm.config}}):_vm._e(),_c('MediaButtons')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }